"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _lodash = require("lodash");
var _classnames = _interopRequireDefault(require("classnames"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var EmailAddress = function EmailAddress(_ref) {
  var className = _ref.className,
    disableLink = _ref.disableLink,
    emailAddress = _ref.emailAddress;
  var email = emailAddress.email_address ? emailAddress.email_address : emailAddress;
  return /*#__PURE__*/_react["default"].createElement("span", {
    className: (0, _classnames["default"])('ui-email-address', className)
  }, disableLink ? email : /*#__PURE__*/_react["default"].createElement("a", {
    href: "mailto:".concat(email),
    title: email
  }, (0, _lodash.truncate)(email, {
    length: 40
  })));
};
EmailAddress.propTypes = {
  /** className */
  className: _propTypes["default"].string,
  /** true to disable the mailto link */
  disableLink: _propTypes["default"].bool,
  /** email address string or object */
  emailAddress: _propTypes["default"].oneOfType([_propTypes["default"].object, _propTypes["default"].string]).isRequired
};
EmailAddress.defaultProps = {
  className: '',
  disableLink: false,
  isInNetworkGroup: true
};
var _default = exports["default"] = EmailAddress;